module.exports = __webpack_public_path__ + "img/Washington outline.4a71552f.png";